const TIME_SEPARATOR = '-';
const INTERVALS_SEPARATOR: string = ',';
export const SINGAPORE_OFFSET_HOURS = 8;

export interface Interval {
  start?: string;
  end?: string;
}

export interface SelectTimeIntervalState {
  // keeping these as states because they are time interval component specific
  intervals: Interval[];
  offsetHours: number;
}

export const parseIntervals = (
  value?: string | string[],
): SelectTimeIntervalState => {
  // this is a direct copy and paste from vlad's code
  // it should work with original design
  // TODO: write tests to this function
  if (value) {
    // [12:12-11:12]+8 will be parsed to '[12:12-11:12]' and '+8'
    const [_ignored, joinedIntervals, offsetHoursString] = /\[(.+)](.+)/.exec(
      String(value).replace(/ /g, ''),
    );

    return {
      intervals: joinedIntervals
        .split(INTERVALS_SEPARATOR)
        .map((intValue: string) => {
          const [start, end]: string[] = intValue.split(TIME_SEPARATOR);
          return { start, end };
        }),
      offsetHours: parseInt(offsetHoursString, 10),
    };
  } else {
    return {
      intervals: [],
      offsetHours: SINGAPORE_OFFSET_HOURS,
    };
  }
};

export const convertIntervalsToString = (
  intervals: Interval[],
  offsetHours: number,
): string => {
  if (intervals.length) {
    const isNegativeOffset = offsetHours < 0;
    const sign: string = isNegativeOffset ? '-' : '+';
    if (isNegativeOffset) {
      offsetHours = -offsetHours;
    }

    const intervalsAsString: string = intervals
      .map(({ start, end }) => `${start}${TIME_SEPARATOR}${end}`)
      .join(`${INTERVALS_SEPARATOR} `);

    return `[${intervalsAsString}]${sign}${offsetHours}`;
  } else {
    return '';
  }
};
